import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { AuthService } from "../../shared/services/auth/auth.service";
let NavComponent = class NavComponent {
    authService;
    sidenav;
    $authenticated;
    constructor(authService) {
        this.authService = authService;
        this.$authenticated = this.authService.$isAuthenticated;
    }
    ngOnInit() {
    }
    toggleSideNav() {
        this.sidenav.toggle();
    }
    onNavOpen() {
        if (!this.sidenav.opened) {
            this.sidenav.opened = true;
        }
    }
    onNavClose() {
        if (this.sidenav.opened) {
            this.sidenav.opened = false;
        }
    }
    static ctorParameters = () => [
        { type: AuthService }
    ];
    static propDecorators = {
        sidenav: [{ type: ViewChild, args: ["sidenav",] }]
    };
};
NavComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-nav",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], NavComponent);
export { NavComponent };
